import React from 'react'
import { WebLink } from '../data/LinkData'
import BannerLink from './BannerLink'
import ButtonLink from './ButtonLink'
import CardLink from './CardLink'
import ExpandedLink from './ExpandedLink'

const LinkDataSplitter: React.FC<{ links: WebLink[] }> = ({ links }) => {
    return <>
        {links.map((link, index) => {
            if (link.type == "title") {
                return <h3 key={index}>
                    {link.title}
                </h3>
            }

            if (link.type == "link") {
                return <ButtonLink key={index} text={link.title} href={link.url} img={link.image} coupon={link.coupon} perc={link.percent} price={link.price} youtube={link.youtube}></ButtonLink>
            }

            if (link.type == "card") {
                return <CardLink key={index} text={link.title} href={link.url} img={link.image} coupon={link.coupon} perc={link.percent} price={link.price}></CardLink>
            }

            if (link.type == "expand") {
                return <ExpandedLink key={index} text={link.title} img={link.image} data={link.data}></ExpandedLink>
            }

            if (link.type == "banner") {
                return <BannerLink key={index} img={link.image} href={link.url}></BannerLink>
            }
        })}
    </>
}

export default LinkDataSplitter